import { AppConstant, DataConstant, ImagesConstant } from "../const";
import { CookieUtils } from ".";
import clsx, { ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { IUploadFile } from "@/models";
import { COOKIE_STORAGE } from "@/const/app.const";
export const getElementById = (id: string) => {
  if (typeof window !== "undefined") {
    return document.getElementById(id);
  }
};

export const getElementByClass = (className: string) => {
  if (typeof window !== "undefined") {
    return document.getElementsByClassName(className);
  }
};

export function debounce<Params extends any[]>(
  func: (...args: Params) => any,
  timeout: number
): (...args: Params) => void {
  let timer: NodeJS.Timeout;
  return (...args: Params) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, timeout);
  };
}

export const toggleAppProgress = (isShow: boolean) => {
  if (typeof window === "undefined") {
    return;
  }
  const progressEl = getElementById(AppConstant.APP_PROGRESS_ID);
  if (progressEl instanceof HTMLElement) {
    progressEl.style.display = isShow ? "flex" : "none";
  }
};

export const getPaginationInfo = (
  take: number,
  skip: number,
  totalData: number
) => {
  const currentPage = Math.ceil(take + skip) / take;
  const totalPage = Math.ceil(totalData / take) || 1;
  return {
    currentPage,
    pageSize: take,
    totalPage,
  };
};

export const setLocalStorage = (name: string, value: string) => {
  if (name) localStorage.setItem(name, value);
};

export const getLocalStorage = (name: string) => {
  if (name) return localStorage.getItem(name);
};

export const handleConfigHeightOfTable = () => {
  const heightWindow = window.innerHeight;
  const tableEl = getElementById("table");
  const paginationEl = getElementById("pagination");

  if (tableEl && paginationEl) {
    const headerHeight = tableEl.getBoundingClientRect().top;
    const paginationHeight = paginationEl.getBoundingClientRect().height;

    tableEl.style.height =
      heightWindow - headerHeight - paginationHeight - 2 + "px";
  }
};

export const urlParserQueryString = (obj?: any) => {
  let str: string[] = [];
  for (let p in obj)
    if (Object.prototype.hasOwnProperty.call(obj, p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

export const isLogined = async () => {
  const accessToken = await CookieUtils.getCookie(COOKIE_STORAGE.AccessToken);
  const refreshToken = await CookieUtils.getCookie(COOKIE_STORAGE.RefreshToken);
  return Boolean(accessToken || refreshToken);
};
export const getFirstCharName = (name: string | null | undefined): string => {
  if (!name || !name.trim()) {
    return "";
  }

  const words = name.trim().split(" ");
  const lastWord = words[words.length - 1];

  if (lastWord) {
    return lastWord[0].toUpperCase();
  }

  return "";
};

export const getRandomColor = (letter: string): string => {
  const listColor: string[] = [
    "#9B1C31",
    "#DECCBE",
    "#54B0AF",
    "#E2583E",
    "#7CC4C3",
    "#C74375",
    "#BF1931",
    "#98B3D1",
    "#964F4D",
    "#AD5D98",
  ];

  const number = letter.charCodeAt(0) % 10;
  return listColor[number];
};
export const cn = (...classes: ClassValue[]) => twMerge(clsx(...classes));
export const convertBase64ToFile = (base64String: string, fileName: string) => {
  const base64Arr = base64String.split(",");
  if (base64Arr.length === 0)
    throw new Error("base64String type không xác định");
  const mimeMatch = base64Arr[0].match(/:(.*?);/);
  if (!mimeMatch) {
    throw new Error("Mime type không xác định");
  }
  const mime = mimeMatch[1];
  const byteString = atob(base64Arr[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new File([ab], fileName, { type: mime });
};

export const convertImageGallery = (data: { name: string; url: string }[]) => {
  return data.map((item) => ({
    original: item.url,
    description: item.name,
    thumbnail: formatThumbUrl(item.url, DataConstant.ThumbSizeEnum.Tiny),
  }));
};
export const formatThumbUrl = (
  url?: string,
  size?: DataConstant.ThumbSizeEnum
) => {
  if (!url) return ImagesConstant.NodataImg;

  return url + "?w=" + (size || DataConstant.ThumbSizeEnum.Small);
};

export const getListUrlFileByText = (text: string) => {
  const regex = /["']https:\/\/media-dev\.thuvien\.edu\.vn\/lms[^\s"']*["']/g;
  const matches = Array.from(text.match(regex) || []).map((c) =>
    c.replace(/^["']|["']$/g, "")
  );
  return matches;
};
export const createPathPattern = (path: string): RegExp => {
  // const escapedPath = path.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // Escape special characters
  // const pattern = escapedPath.replace(/\[([^\]]+)\]/g, "[^/]+"); // Replace [id] with a pattern that matches any segment

  const escapedPath = path.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // Escape special characters
  const pattern = escapedPath.replace(/\\\[([^\]]+)\\\]/g, "[^/]+"); // Replace [id] with a pattern that matches any segment
  return new RegExp(`^${pattern}$`);
};
